// extracted by mini-css-extract-plugin
export default {"root":"IconFavouriteHeart_root__9zHzu","small":"IconFavouriteHeart_small__u+xTY","large":"IconFavouriteHeart_large__dg05a"};